import Swal from 'sweetalert2';

export const showLoadingAlert = (title = 'Processing...', { allowOutsideClick = true } = {}) => {
    Swal.fire({
        title,
        showConfirmButton: false,
        allowOutsideClick: allowOutsideClick ?? true,
        didOpen: () => {
            Swal.showLoading();
        },
    });
};

export const showSuccessAlert = (message = 'Done') => {
    Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: message,
        timer: 0.001,
        showConfirmButton: false,
    });
};
export const showErrorAlert = (error) => {
    const errorMessage = error?.message || 'Operation failed. Changes saved locally.';
    Swal.fire({
        icon: 'error',
        title: 'Error',
        html: `
        <div style="display: flex; flex-direction: column; align-items: center;">
          <div style="font-size: 18px;">${errorMessage}</div>
        </div>`,
        showCancelButton: true,
        cancelButtonText: 'Close',
        showConfirmButton: false,
        focusConfirm: false,
        // didOpen: () => {
        //     document.activeElement.blur(); // explicitly blur focused element to avoid scroll
        //   },
    });
};

export const showConfirmationAlert = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
    });
};
